import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Pricing from "./components/Pricing";
import Team from "./components/Team";
import Contact from "./components/Contact";
import BottomBar from "./components/BottomBar";

function App() {
  return (
    <div className="App w-full max-w-[100vw] overflow-x-hidden relative">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Pricing />
      <Team />
      <Contact />
      <BottomBar />
    </div>
  );
}

export default App;

